
import { toast } from "sonner";

export const useFormValidation = (
  createNewFormTemplate: () => void,
  setActiveTab: (value: string) => void,
  setIsEditing: (value: boolean) => void
) => {
  // Function to validate shop ID and create a new form
  const validateShopIdAndCreateForm = (shopId: string | undefined) => {
    // Verify if the shop ID is valid before attempting to create a form
    if (!shopId || typeof shopId !== 'string' || 
        !shopId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      toast.error("Erreur", {
        description: "L'ID de la boutique n'est pas valide. Impossible de créer un formulaire."
      });
      return false;
    }
    
    createNewFormTemplate();
    setActiveTab("editor");
    setIsEditing(true);
    return true;
  };

  // Function to validate shop ID for saving
  const validateShopIdForSaving = (shopId: string | undefined) => {
    if (!shopId || typeof shopId !== 'string' || 
        !shopId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
      toast.error("Erreur", {
        description: "L'ID de la boutique n'est pas valide. Impossible de sauvegarder le formulaire."
      });
      return false;
    }
    return true;
  };

  return {
    validateShopIdAndCreateForm,
    validateShopIdForSaving
  };
};
